// Third party libraries
import * as $ from 'jquery';

// Mixins
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

export default {
	name: 'ModalFindReplaceWithBreedName',
	mixins: [inputTextMixins],
	data() {
		return {
			modalContent: {},
			search: ``,
			stringCount: 0
		}
	},
	computed: {
		isDisabled() {
			return this.stringCount > 0 ? false : true;
		}
	},
	beforeDestroy() {
		this.hideModal();
	},
	methods: {
		show(modalContent) {
			this.search = ``;
			Object.keys(modalContent).forEach((fieldName) => {
				this.modalContent[fieldName] = modalContent[fieldName].split(" ");
			});
			this.stringCount = 0;
			$(this.$refs.modalFindReplaceWithBreedName).modal('show');
		},
		hideModal() {
			$(this.$refs.modalFindReplaceWithBreedName).modal('hide');
		},
		searchKeyUp() {
			if (this.search) {
				this.delayTyping(() => {
					this.stringCount = 0;
					Object.keys(this.modalContent).forEach((fieldName) => {
						this.modalContent[fieldName].forEach((word) => {
							if(this.search == word) {
								this.stringCount++;
							}
						})
					});
				});
			}
		},
		replaceString() {
			Object.keys(this.modalContent).forEach((fieldName) => {
				this.modalContent[fieldName].forEach((word, index) => {
					if(this.search == word) {
						this.modalContent[fieldName][index] = 'BREED_NAME';
					}
				})
				this.modalContent[fieldName] = this.modalContent[fieldName].join(" ");
			});
			this.$emit('replaceBodyWithBreedName', this.modalContent);
			this.hideModal();
		}
	}
}